// extracted by mini-css-extract-plugin
module.exports = {"docLink":"DocLink_docLink__1mHpE"};